import { colors } from "@material-ui/core";

const white = "#FFFFFF";
const black = "#000000";
const darkGray = "#14161A";
const borderGray='#7D7D7D';

export default {
	darkGray,
	black,
	white,
	borderGray,
	primary: {
		contrastText: white,
		dark: "#b59407",
		main: "#FECE00",
		light: "#ffe266",
		yellow:'#E7A701',
	},
	secondary: {
		contrastText: black,
		dark: "#D8D8D8",
		main: "#7383B1",
		light: "#252525"
	},
	success: {
		contrastText: white,
		dark: colors.green[900],
		main: colors.green[600],
		light: colors.green[100]
	},
	info: {
		contrastText: white,
		dark: colors.blue[900],
		main: colors.blue[600],
		light: colors.blue[100]
	},
	warning: {
		contrastText: white,
		dark: colors.orange[900],
		main: colors.orange[600],
		light: colors.orange[400]
	},
	error: {
		contrastText: white,
		dark: colors.red[900],
		main: colors.red[600],
		light: colors.red[100]
	},
	text: {
		primary: colors.blueGrey[900],
		secondary: colors.blueGrey[600],
		link: colors.blue[600]
	},
	background: {
		dark: colors.grey[800],
		darker: colors.grey[900],
		default: "#F4F6F8",
		paper: white
	},
	icon: colors.blueGrey[600],
	divider: colors.grey[200],
	transparent: "#00000000"
};
